import type { AccessGroup } from "types";
import { DEFAULT_ACCESS_GROUP_FILTER } from "utilities/constants/constants";

const filterDefaultAccessGroups = ({ displayName }: AccessGroup): boolean =>
	DEFAULT_ACCESS_GROUP_FILTER.IT_FOR_YOUR_EMPLOYEES.some((filter: string) =>
		displayName.toUpperCase().includes(filter.toUpperCase()),
	);

export { filterDefaultAccessGroups };
